
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Constants.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export class StorageContainer {
	static contractAttachments: StorageContainerType = 'contracts';
	static taskAttachments: StorageContainerType = 'attachments';
	static debtCollection: StorageContainerType = 'debtcollectionexports';
	static mailAttachments: StorageContainerType = 'mail-attachments';

	static values = ['contracts', 'attachments', 'debtcollectionexports', 'mail-attachments'];
}
export type StorageContainerType = 'contracts' | 'attachments' | 'debtcollectionexports' | 'mail-attachments';

